import React from 'react';
import NavigationArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward';

let touchStart = 0;
let touchEnd = 0;
let dragSize = 0;

let viewElement = '';

const RefreshIndicator = React.createClass({
	componentDidMount: function() {
		viewElement = document.querySelector('.' + this.props.viewClass);
		if (viewElement) {
			viewElement.addEventListener('touchstart', this._startDrag, false);
			viewElement.addEventListener('touchend', this._endDrag, false);
			viewElement.addEventListener('touchmove', this._dragActive, false);
		}
	},
	_startDrag: function(event) {
		if (viewElement.getBoundingClientRect().top === viewElement.offsetTop) {
			touchStart = event.changedTouches[0].clientY;
		}
	},
	_dragActive: function(event) {
		if (touchStart !== 0 && viewElement.getBoundingClientRect().top === viewElement.offsetTop) {
			touchEnd = event.changedTouches[0].clientY;
			dragSize = touchEnd - touchStart;
			document.querySelector('.pull').classList.add('active');
			document.getElementById('refresh').style.height = dragSize/2;
		}
		if (dragSize/2 > 80) {
			document.getElementById('refresh').classList.add('active');
		} else {
			document.getElementById('refresh').classList.remove('active');
		}
	},
	_endDrag: function(event) {
		if (dragSize/2 > 80) {
			document.getElementById('refresh').style.height = '80px';
			document.querySelector('.pull').classList.remove('active');
			document.querySelector('.loading').classList.add('active');
			this.props.request();
			setTimeout(function(){
				document.getElementById('refresh').style.height = '0';
				document.querySelector('.loading').classList.remove('active');
			}, 1000);
		} else {
			document.getElementById('refresh').style.height = '0';
		}
		touchStart = 0;
		touchEnd = 0;
		dragSize = 0;
	},
	componentWillUnmount: function() {
		if (viewElement) {
			viewElement.removeEventListener('touchstart', this._startDrag);
			viewElement.removeEventListener('touchmove', this._dragActive);
			viewElement.removeEventListener('touchend', this._endDrag);
		}
	},
	render: function() {
		const style = {
			arrow: {
				fill: '#427AA1',
			},
			refresh: {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'flex-end',
				flex: '0 0 100%',
				height: '0',
				zIndex: '90',
				overflow: 'hidden',
				backgroundColor: 'rgba(185, 229, 225, 0.7)'
			}
		};
		return (
			<div id="refresh" style={style.refresh}>
				<span className="active pull">
					<NavigationArrowDownward style={style.arrow} />
				</span>
				<span className="loading">
					<span id="dot1"></span>
					<span id="dot2"></span>
					<span id="dot3"></span>
				</span>
			</div>
		)
	}
});

export default RefreshIndicator;



// WEBPACK FOOTER //
// ./src/components/refreshIndicator.jsx